import { render, staticRenderFns } from "./FrontHeadLamp.vue?vue&type=template&id=2c40ee3c"
import script from "./FrontHeadLamp.vue?vue&type=script&lang=js"
export * from "./FrontHeadLamp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports